// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project-imports

import menu from './menu';
import snackbar from './snackbar';

import cartReducer from './cart';
import project from './project';
import customer from './customer';
import lead from './lead';
import followUp from './follow-up';
import employee from './employee';
import formData from './form-data';
import lifeStage from './life-stage';
import source from './source';
import proposalTemplate from './proposal-template';
import proposal from './proposal';
import quotation from './quotation';
import projectTask from './project-task';
import employeeTask from './employee-task';
import invoice from './invoice';
import orderMaterial from './order-material';
import supplier from './supplier';
import calendar from './calendar';
import leaveType from './leave-type';
import attendance from './attendance';
import transaction from './transaction';
import vat from './vat';
import business from './business';
import activity from './activity';
import leaveApplication from './leave-application';
import task from './task';
import purchase from './purchase';
import role from './role';
import department from './hr/department';
import award from './hr/award';
import expense from './hr/expense';
import noticeboard from './hr/noticeboard';
import holiday from './hr/holiday';
import payroll from './hr/payroll';
import employeeRole from './employee-role';
import dashboard from './dashboard';
import leadKanban from './lead-kanban';
import asset from './asset';
import assetLocation from './asset-location';
import assetType from './asset-type';
import assetStatus from './asset-status';
import maintenance from './maintenance';
import survey from './survey';
import snagging from './snagging';
import accountReports from './accountReports';
import projectsDashboard from './projects-dashboard';
import projectTaskCalender from './project-task-calender';
import taskReports from './task-reports';
import orderMaterialReports from './order-material-reports';
import projectFeedback from './project-feedback';
import customerProjectFeedback from './customer-project-feedback';
import genericSurvey from './generic-survey';
import notification from './notification';
import webVersion from './web-version';
import invoiceOutstanding from './invoice-outstanding';
import dashboardyearly from './dashboardYearly';
import yearSums from './yearSums';
import dashboardLineChart from './dashboardLineChart';
import leaveCalendar from './leave-calendar';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  formData,
  employee,
  assetStatus,
  notification,
  assetType,
  customer,
  lead,
  maintenance,
  projectTask,
  employeeTask,
  snagging,
  accountReports,
  followUp,
  lifeStage,
  proposalTemplate,
  orderMaterial,
  proposal,
  source,
  survey,
  genericSurvey,
  customerProjectFeedback,
  menu,
  payroll,
  snackbar,
  invoice,
  transaction,
  project,
  quotation,
  supplier,
  department,
  award,
  expense,
  purchase,
  noticeboard,
  calendar,
  holiday,
  attendance,
  leaveType,
  dashboard,
  vat,
  assetLocation,
  leadKanban,
  business,
  activity,
  task,
  role,
  asset,
  webVersion,
  projectTaskCalender,
  employeeRole,
  leaveApplication,
  leaveCalendar,
  projectsDashboard,
  taskReports,
  projectFeedback,
  orderMaterialReports,
  invoiceOutstanding,
  dashboardyearly,
  dashboardLineChart,
  yearSums,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'new-look-ts-'
    },
    cartReducer,
   
  ),

});

export default reducers;
